import React, { Component } from "react"
import moment from "moment"
import DynamicFormTypes from "../../Types/DynamicFormsTypes"
import { Table } from "react-bootstrap"
import Loader from "src/components/common/Loader"
import DynamicFormsContextMenu from "./DynamicFormsContextMenu/DynamicFormsContextMenu"
import stateMutator from "../../Utils/StateMutator"
import "./DynamicFormsList.css"
interface Props {
    forms: Array<DynamicFormTypes>
    formTypes: Array<{ CustomFormTypeId: number, Type: string }>
    manageParentState: Function
    busy: boolean
    hints: boolean
}
interface State {
    showContextMenu: boolean
    stopRowPropagation: boolean
}
class DynamicFormsList extends Component<Props, State> {

    timeFormat = "MM/DD/YY h:mm a"
    date = new Date()
    timeZoneOffset = -this.date.getTimezoneOffset()

    state = {
        showContextMenu: false,
        stopRowPropagation: false
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(stateMutator.mutate(this.state, keys))
    }

    getTextFromFormTypeReference = (CustomFormTypeId: number) => {
        const formType = this.props.formTypes.filter(obj => {
            return obj.CustomFormTypeId === CustomFormTypeId
        })[0].Type
        return formType || "Unknown"
    }

    showOrHideControls = (show: boolean, i: number) => {
        const display = show ? "block" : "none"
        let elem = document.getElementById(`dynamic-forms-table-context-menu-${i}`)
        if (elem) {
            elem.style.display = display
        }
    }

    removeUnauthorizedForms = () => {//!!!fix this
        let formList = []
        const forms = this.props.forms
        const formTypes =this.props.formTypes
        for (let i = 0; i < forms.length; i++) {
            for (let j = 0; j < formTypes.length; j++) {
                if(forms[i].CustomFormTypeId === formTypes[j].CustomFormTypeId){
                    formList.push(forms[i])
                }
            }
        }
        return formList
    }

    tableItems = [
        { title: "Name", key: "Name", order: 1 },
        { title: "Created", key: "CreatedDate", order: 3, isDate: true },
        { title: "Type", key: "Type", order: 2, referenceHelper: { key: "CustomFormTypeId", function: this.getTextFromFormTypeReference } },
    ].sort(({ order: a }, { order: b }) => a - b)


    render() {

        const props = this.props
        const state = this.state
        const forms = this.removeUnauthorizedForms()
        const tableItems = this.tableItems
        const stopRowPropagation = state.stopRowPropagation

        // console.log("???", props)

        return (
            <div className="DynamicFormsList">
                {!props.busy && <div className="DynamicFormsList">
                    <Table striped bordered hover>
                        <thead>
                            <tr id="dynamic-forms-list-table-header">
                                {tableItems.map((item, i) =>
                                    <th id={`dynamic-forms-list-table-header-th-${item.key.toLowerCase()}`} key={`dynamic-forms-list-table-header-th-${i}`}>
                                        {item.title}
                                    </th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {forms && forms.map((form: DynamicFormTypes, i: number) =>
                                <tr
                                    id={`dynamic-forms-list-table-tr-${i}`}
                                    key={`dynamic-forms-list-table-tr-${i}`}
                                    onMouseEnter={() => this.showOrHideControls(true, i)}
                                    onMouseLeave={() => this.showOrHideControls(false, i)}
                                >
                                    {tableItems.map((item, j) =>
                                        <td id={`dynamic-forms-list-table-td-${item.key.toLowerCase()}`} key={`dynamic-forms-list-table-td-${j}`}
                                            onClick={stopRowPropagation ? () => null : () => props.manageParentState([{ key: "formToPreview", value: form }])}
                                        >
                                            <div className="DynamicFormsListTDWrapper">
                                                {/*@ts-ignore*/
                                                    item.referenceHelper ? item.referenceHelper.function(form[item.referenceHelper.key])
                                                        /*@ts-ignore*/
                                                        : item.isDate ? moment.utc(form[item.key]).utcOffset(this.timeZoneOffset).format(this.timeFormat)
                                                            /*@ts-ignore*/
                                                            : form[item.key]}
                                                {j === tableItems.length - 1 &&
                                                    <DynamicFormsContextMenu
                                                        manageParentState={this.manageState}
                                                        manageGrandparentState={props.manageParentState}
                                                        form={form}
                                                        index={i}
                                                        hints={props.hints}
                                                        show={state.showContextMenu}
                                                        flip={i > 5}
                                                    />}

                                            </div>
                                        </td>)}
                                </tr>)}
                        </tbody>
                    </Table>
                </div>}
                {props.busy && <div className="DynamicFormsListLoadingList">
                    <span className="material-icons">dynamic_feed</span>
                    <Loader title="Loading forms" />
                </div>}
            </div>
        )
    }
}

export default DynamicFormsList